import { State } from '../../reducers/rootReducer'
import LastConfigurationInfo from '../../../entities/LastConfigurationInfo'

const lastConfigurationsInfoSelector = (state: State): LastConfigurationInfo => state.lastConfigurationsInfo

export default lastConfigurationsInfoSelector
